import { DEFAULT_CONFIG, PU_TYPES } from '../engine/config.js';
import { model } from '../engine/state.js';

function speedEffectTotalTicks() {
  const configured = Number(model.config.speedEffectTicks);
  if (Number.isFinite(configured) && configured > 0) return configured;
  const tickMs = Math.max(1, Number(model.config.tickMs) || 16);
  return Math.max(1, Math.round(3000 / tickMs));
}

function speedStackBonus() {
  const configured = Number(model.config.speedStackBonus);
  if (Number.isFinite(configured) && configured > 0) return configured;
  return 1;
}

function speedTurnRadiusMul() {
  const configured = Number(model.config.speedTurnRadiusMul);
  if (Number.isFinite(configured) && configured >= 1) return configured;
  return DEFAULT_CONFIG.speedTurnRadiusMul;
}

// 0 or absent means uncapped, matching the server (CF2/CurveCrash impose no
// limit on overlapping speed boosts). This must agree with the server exactly:
// clamping here to a cap the server is not applying would predict the local
// player at a slower speed than it is actually moving.
function speedMaxStacks() {
  const configured = Number(model.config.speedMaxStacks);
  if (!Number.isFinite(configured) || configured <= 0) return Infinity;
  return Math.max(1, Math.floor(configured));
}

function speedEffectStackCount(effect) {
  if (!effect || effect.type !== PU_TYPES.SPEED || (Number(effect.ticks) || 0) <= 0) return 0;
  const rawStacks = Number(effect.stacks);
  if (!Number.isFinite(rawStacks)) return 1;
  return Math.min(speedMaxStacks(), Math.max(1, Math.floor(rawStacks)));
}

function playerSpeedMultiplier(player) {
  const stacks = speedEffectStackCount(player?.effect);
  if (stacks <= 0) return 1;
  return Math.pow(1 + speedStackBonus(), stacks);
}

function playerTurnRadiusMultiplier(player) {
  const stacks = speedEffectStackCount(player?.effect);
  if (stacks <= 0) return 1;
  return Math.pow(speedTurnRadiusMul(), stacks);
}

export {
  speedEffectTotalTicks,
  speedStackBonus,
  speedTurnRadiusMul,
  speedEffectStackCount,
  playerSpeedMultiplier,
  playerTurnRadiusMultiplier
};
